import _ajaxByAxios from './_ajaxByAxios'
import _funsForMix from './_funsForMix'
import _tableForMix from './_tableForMix'

export const _ajax = _ajaxByAxios
export const _funs = _funsForMix
export const _table = _tableForMix
